import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Templates = () => {
  return (
    <EmptyPage
      title="Document Templates"
      description="Manage and customize document templates for contracts, reports, valuations, and other real estate documentation needs."
      icon="📄"
    />
  );
};

export default Templates;
